import FocusTrap from './focus-trap';
import { fadeIn, fadeOut } from './animations';

export default class Modal {
    constructor(
        modalId,
        openButtons,
        closeModalClass,
        innerModalClass,
        isOpen = false
    ) {
        this.isOpen = isOpen;
        this.modal = document.getElementById(modalId);
        this.openButtons = openButtons;
        this.lastOpenButtonClicked = null;
        this.closeModalButton = this.modal.querySelectorAll(
            `.${closeModalClass}`
        );
        this.innerModalClass = innerModalClass;
        this.focusTrap = new FocusTrap(this.modal);
        // eslint-disable-next-line prefer-destructuring
        this.html = document.getElementsByTagName('html')[0];
        this.openListeners = [];
        this.closeListeners = [];
        this.onClickOutside = this.onClickOutside.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    addEventListener(event, callback) {
        switch (event) {
            case 'open':
                this.openListeners.push(callback);
                break;
            case 'close':
                this.closeListeners.push(callback);
                break;
            default:
                break;
        }
    }

    init() {
        [...this.openButtons].forEach((button) => {
            button.addEventListener('click', this.onOpen.bind(this));
        });
        [...this.closeModalButton].forEach((button) => {
            button.addEventListener(
                'click',
                this.onCloseModalButton.bind(this)
            );
        });
        window.openModals = window.openModals || [];
    }

    onCloseModalButton(event) {
        if (this.onClose()) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onOpen(event) {
        this.isOpen = true;
        const thisObj = this;
        this.lastOpenButtonClicked = event.currentTarget;
        this.html.classList.add('overflow-hidden');
        this.modal.classList.remove('hidden');
        fadeIn(this.modal, 0.3, () => {
            thisObj.openListeners.forEach((callback) => {
                callback();
            });
        });
        window.openModals.push(this.modal);
        this.focusTrap.activate();
        this.focusTrap.firstFocusableElement.focus();
        window.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('click', this.onClickOutside);
        // Without stopPropagation, the above event handler would fire immediately and close the modal
        event.stopPropagation();
    }

    onClose() {
        // This ensures that multiple open modals are closed in the correct order
        if (
            !window.openModals.length ||
            window.openModals[window.openModals.length - 1] !== this.modal
        ) {
            return false;
        }
        this.isOpen = false;
        const thisObj = this;
        this.html.classList.remove('overflow-hidden');
        fadeOut(this.modal, 0.3, () => {
            this.modal.classList.add('hidden');
            thisObj.closeListeners.forEach((callback) => {
                callback();
            });
        });
        window.openModals.pop();

        this.focusTrap.deactivate();
        if (this.lastOpenButtonClicked) {
            this.lastOpenButtonClicked.focus();
        } else if (this.openButtons.length > 0) {
            this.openButtons[this.openButtons.length - 1].focus();
        }

        window.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('click', this.onClickOutside);
        return true;
    }

    onKeyDown(event) {
        if (event.key === 'Escape') {
            if (this.onClose()) {
                event.preventDefault();
            }
        }
    }

    onClickOutside(event) {
        if (event.target.closest(`.${this.innerModalClass}`) === null) {
            if (this.onClose()) {
                event.preventDefault();
            }
        }
    }
}
